export default {
    modal: {
        actEnd: {
            title: '活动已结束',
            desc: '您可前往活动中心查看更多活动',
            btn: '参与更多精彩活动'
        },
        noCrowd: {
            title: '本活动仅对部分用户开放',
            desc: '参与更多精彩活动',
            btn: '去看看'
        }
    },
    message: {
        sendSuccess: '恭喜 获得奖励'
    }
};
